var _dec, _class, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { getOwner } from '@ember/application';
import Service, { inject as service } from '@ember/service';
import * as Sentry from '@sentry/browser';
import { Severity } from '@sentry/browser';
let EmberMultipassLoggingService = (_dec = service('ember-multipass-config'), (_class = class EmberMultipassLoggingService extends Service {
  get canLog() {
    return !this.multipassConfig.isProduction;
  }
  constructor(properties) {
    super(properties);
    _initializerDefineProperty(this, "multipassConfig", _descriptor, this);
    _defineProperty(this, "sentryClient", void 0);
    const config = getOwner(this).resolveRegistration('config:environment');

    // Initialize Sentry
    let sentryDsn = '';
    if (this.multipassConfig.isProduction) {
      sentryDsn = config['ember-multipass-components'].sentry.dsn_production;
    } else if (this.multipassConfig.isStaging) {
      sentryDsn = config['ember-multipass-components'].sentry.dsn_staging;
    }
    this.sentryClient = new Sentry.BrowserClient({
      dsn: sentryDsn
    });
  }
  log(...args) {
    if (!this.canLog) {
      return;
    }
    console.log(...args);
  }
  error(...args) {
    if (!this.canLog) {
      return;
    }
    console.error(...args);
  }
  sentryMessage(message, fingerprint, severity) {
    const scope = this.getSentryScope(fingerprint);
    this.sentryClient.captureMessage(message, severity ?? Severity.Warning, undefined, scope);
  }
  sentryError(fingerprint, error) {
    const scope = this.getSentryScope(fingerprint);
    this.sentryClient.captureException(error, undefined, scope);
  }
  getSentryScope(fingerprint) {
    const scope = new Sentry.Scope();
    scope.setTags({
      manually_captured: true
    });
    scope.setExtra('hostname', window.location.hostname);
    scope.setExtra('pathname', window.location.pathname);
    scope.setFingerprint(fingerprint);
    return scope;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "multipassConfig", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export { EmberMultipassLoggingService as default };